/* @flow */
export const createEditorId = (name: string): string => `slate-editor-root-${name}`;
export const createEditorPortalRootId = (editorId: string): string => `${editorId}-portal-root`;